import { List } from '@mui/material';
import { useIsDesktop, useNotifications } from 'Hooks';
import { Document } from './Document';
import { Update } from './Update';
import { NoNewUpdatesOrDocuments } from './Update/NoNewUpdatesOrDocuments';

interface IUpdatesProps {
  index: number;
}

export const NotificationsList = ({ index }: IUpdatesProps) => {
  const { updates, documents } = useNotifications();
  const { benefits, referrals, other } = updates;

  const isDesktop = useIsDesktop();

  const concatMessages = () => {
    const allMessages: any[] = [];

    if (index === 0) {
      if (benefits !== undefined && benefits.amount !== 0) {
        allMessages.push(benefits);
      }
      if (referrals !== undefined && referrals.amount !== 0) {
        allMessages.push(referrals);
      }
      other.forEach((update) => allMessages.push(update));
    } else if (index === 1) {
      documents.forEach((document) => allMessages.push(document));
    }

    return allMessages;
  };

  return (
    <List
      sx={{
        mb: isDesktop ? 0 : 10,
      }}
    >
      {concatMessages().length === 0 && (
        <NoNewUpdatesOrDocuments index={index} />
      )}
      {concatMessages().map((item, i) =>
        index === 0 ? (
          <Update message={item} key={i} />
        ) : (
          <Document document={item} key={i} />
        )
      )}
    </List>
  );
};
